import { Breadcrumb } from '@/components/elements/Breadcrumb';
import { IComponentSharedHero, IComponentSharedHeroVideo } from '@/graphql/__generated__/global/types';
import { type BreadcrumbsType } from '@/lib/getBreadcrumbs';
import HeroImage from '../HeroImage/HeroImage';
import HeroVideo from '../HeroVideo/HeroVideo';

type HeroProps = IComponentSharedHero & { pageType: 'StoryEntity' | 'PageEntity'; breadcrumbs?: BreadcrumbsType[] };

export const Hero = ({ image, video, title, description, showBreadcrumbs, showBookingBar, bookingBarText, breadcrumbs, pageType }: HeroProps) => {
    return (
        <div className="relative">
            <Breadcrumb breadcrumbs={breadcrumbs} showBreadcrumbs={showBreadcrumbs} className="absolute top-[8rem] lg:top-24 left-10 z-10" />
            {video?.backgroundVideo?.data && (
                <HeroVideo
                    bookingBarText={bookingBarText}
                    showBookingBar={showBookingBar}
                    {...(video as IComponentSharedHeroVideo)}
                    title={title}
                    description={description}
                    pageType={pageType}
                />
            )}
            {image && !video?.backgroundVideo?.data && (
                <HeroImage showBookingBar={showBookingBar} bookingBarText={bookingBarText} {...image} title={title as string} description={description} />
            )}
        </div>
    );
};

export default Hero;
